import { render, staticRenderFns } from "./UploadFormItem.vue?vue&type=template&id=614c0ec7&scoped=true&"
import script from "./UploadFormItem.vue?vue&type=script&lang=js&"
export * from "./UploadFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../.jenkins/workspace/DMSDashboardDeployLIVE/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614c0ec7",
  null
  
)

export default component.exports